export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGOUT_ACTION = "LOGOUT_ACTION";
export const SET_TOKEN_ACTION = "SET_TOKEN_ACTION";

export const LOGIN_REST_STARTED = "LOGIN_REST_STARTED";
export const LOGIN_REST_SUCCESS = "LOGIN_REST_SUCCESS";
export const LOGIN_REST_FAILED = "LOGIN_REST_FAILED";

export const login = (username, password, userEnteredCaptchaCode, captchaId) => {
	return {
		type: LOGIN_ACTION,
		username,
		password,
		userEnteredCaptchaCode,
		captchaId
	};
};

export const loginRest = (username, password, userEnteredCaptchaCode, captchaId) => {

	return (dispatch, getState) => {

        dispatch(loginRestStarted());

		let inputBody = {
			username: username,
			password: password,
			userEnteredCaptchaCode: userEnteredCaptchaCode,
			captchaId: captchaId
		};

		return fetch("/ndapmoci/login", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(inputBody)
		})
			.then(response => {
				if (!response.ok) throw Error(response.statusText);
				return response;
			})
			.then(response => response.json())
			.then(responseJson => {
                //console.log(responseJson);
                dispatch(loginRestSuccesfull(responseJson));
			})
			.catch(error => {
                console.error(error);
                dispatch(loginRestFailed(error));
			});
	};
};

export const loginRestStarted = () => {
    return {
        type: LOGIN_REST_STARTED
    }
}

export const loginRestSuccesfull = (loginData) => {
    return {
        type: LOGIN_REST_SUCCESS,
        loginData
    };
};

export const loginRestFailed = (loginError) => {
    return {
        type: LOGIN_REST_FAILED,
        loginError
    };
};

export const logout = () => {
	return {
		type: LOGOUT_ACTION
	};
};

export const setTokenAction = token => {
	return {
		type: SET_TOKEN_ACTION,
		token
	};
};



// WEBPACK FOOTER //
// ./src/features/common/login/login-form/LoginActions.jsx